<!-- Ticker.vue: 現在時刻のラインを表示する -->
<template lang="html">
  <div id="ticker" :style="getStyle" v-show="isEnable()">↑now</div>
</template>
<script>
import {
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      time: new Date(),
      style: {
        width: this.tableWidth + 'px',
        height: '0px',
        left: '0px',
        top: '0px',
        'margin-left': '0px'
      },
      intID: 0
    }
  },
  computed: {
    ...mapGetters([
      'tableWidth',
      'timeToPosition'
    ]),
    getStyle () {
      return this.style
    }
  },
  methods: {
    updateStyle () {
      if (this.time.getHours() < 10 || (this.time.getHours() >= 22 && this.time.getMinutes() >= 0)) {
        this.style.top = '0px'
        clearInterval(this.intID)
      }
      let top = this.timeToPosition(this.time.getHours() + ':' + this.time.getMinutes()) +
        this.$store.state.tbHeaderHeight + this.$store.state.headerHeight
      let width = window.innerWidth
      this.style.top = top + 'px'
      this.style.width = width + 'px'
    },
    isEnable () {
      return !(this.time.getHours() < 10 || (this.time.getHours() >= 22 && this.time.getMinutes() >= 0)) &&
        (this.time.getDate() === this.$store.state.curDate.getDate() && this.time.getMonth() === this.$store.state.curDate.getMonth())
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateStyle()
      this.intID = setInterval(() => {
        this.time = new Date()
        this.updateStyle()
      }, 1000 * 60)
    })
  }
}
</script>

<style lang="css" scoped>
#ticker {
  text-align: left;
  position: absolute;
  border-style: solid;
  color: #ffd500;
  border-color: #ffd500;
  opacity: 0.8;
  border-width: 1px;
  height: 1px;
  overflow: visible;
  z-index: 1002;
}
</style>



// WEBPACK FOOTER //
// Ticker.vue?17a3c006